import React, { useState } from "react";
import useDatos from "../pages/Mostrar/useDatos";
import { FaSortUp, FaSortDown, FaEdit, FaTrash } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./MostrarInmuebles.css";
import HeaderRoot from "./HeaderRoot"
import API from "./Fetchs";

const MostrarInmueblesTabla = ({ tipo = "" }) => {
  const url = API.read;
  const { datos: inmuebles = [], loading, error } = useDatos(url);

  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const handleEliminar = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este inmueble permanentemente?")) return;

    try {
      const response = await fetch(API.delete, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id }),
      });

      const data = await response.json();

      if (!response.ok || !data.success) {
        throw new Error(data.message || "Error en la eliminación");
      }

      // Recargar la página para actualizar la lista
      window.location.reload();
    } catch (err) {
      console.error("Error en eliminación:", err);
      alert(err.message || "Error al contactar con el servidor");
    }
  };
  // Función para ordenar los datos
  const sortedData = () => {
    if (!Array.isArray(inmuebles)) return [];

    let sortableItems = [...inmuebles];
    if (sortConfig.key) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return "N/A";
    const date = new Date(fecha);
    if (isNaN(date)) return "Fecha inválida";

    return date.toLocaleString("es-AR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };



  if (loading) return <p className="text-center">Cargando propiedades...</p>;
  if (error) return <p className="text-center text-danger">Error: {error.message}</p>;

  const inmueblesFiltrados = Array.isArray(inmuebles)
    ? tipo
      ? inmuebles.filter(
        (inmueble) =>
          inmueble.tipo_inmueble.toLowerCase() === tipo.toLowerCase()
      )
      : inmuebles
    : [];

  const headers = [
    { key: "id", label: "ID" },
    { key: "direccion", label: "Dirección" },
    { key: "lugar", label: "Lugar" },
    { key: "tipo_inmueble", label: "Tipo de Inmueble" },
    { key: "cantidad_hectareas", label: "Hectáreas" },
    { key: "superficie_terreno", label: "Superficie Terreno" },
    { key: "medida_frente", label: "Medida Frente" },
    { key: "medida_fondo", label: "Medida Fondo" },
    { key: "superficie_cubierta", label: "Sup. Cubierta" },
    { key: "superficie_semicubierta", label: "Sup. Semicubierta" },
    { key: "descripcion", label: "Descripción" },
    { key: "ubicacion", label: "Ubicación Google Maps" },
    { key: "fecha_carga", label: "Fecha" },
    { key: "acciones", label: "Acciones" },
  ];

  return (

    <>
      <HeaderRoot />
      <div className=" mt-5">
        {inmueblesFiltrados.length === 0 ? (
          <div className="alert alert-info text-center">
            No hay propiedades disponibles en esta categoría
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="table-dark">
                <tr>
                  {headers.map((header) => (
                    <th
                      key={header.key}
                      onClick={() => handleSort(header.key)}
                      style={{ cursor: "pointer" }}
                    >
                      {header.label}{" "}
                      {sortConfig.key === header.key &&
                        (sortConfig.direction === "asc" ? (
                          <FaSortUp />
                        ) : (
                          <FaSortDown />
                        ))}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {sortedData().map((inmueble) => (
                  <tr key={inmueble.id}>
                    <td>{inmueble.id}</td>
                    <td>{inmueble.direccion || "N/A"}</td>
                    <td>{inmueble.lugar || "N/A"}</td>
                    <td>{inmueble.tipo_inmueble || "N/A"}</td>
                    <td>{inmueble.cantidad_hectareas || "N/A"}</td>
                    <td>{inmueble.superficie_terreno || "N/A"}</td>
                    <td>{inmueble.medida_frente || "N/A"}</td>
                    <td>{inmueble.medida_fondo || "N/A"}</td>
                    <td>{inmueble.superficie_cubierta || "N/A"}</td>
                    <td>{inmueble.superficie_semicubierta || "N/A"}</td>
                    <td>
                      {inmueble.descripcion
                        ? inmueble.descripcion.length > 20
                          ? `${inmueble.descripcion.slice(0, 20)}...`
                          : inmueble.descripcion
                        : "N/A"}
                    </td>

                    <td>
                      {inmueble.ubicacion ? (
                        <a
                          href={inmueble.ubicacion}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                        >
                          Ver en Google Maps
                        </a>
                      ) : (
                        "N/A"
                      )}
                    </td>
                    <td>{formatearFecha(inmueble.fecha_carga)}</td>
                    <td>
                      <Link to={`/editar/${inmueble.id}`} className="btn btn-warning btn-sm">
                        <FaEdit className="me-2" />
                        Editar
                      </Link>
                    </td>
                    <td>
                      <td>
                        <button onClick={() => handleEliminar(inmueble.id)} className="btn btn-danger">
                          <FaTrash className="me-2" />
                          Eliminar
                        </button>
                      </td>

                    </td>

                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </>
  );
};

export default MostrarInmueblesTabla;
